export { default } from "./AppTabs";
